import React from 'react'
import HomeComponent from '../Components/Home/'

const Home = () => {
  return <HomeComponent />
}

export default Home
